// extracted by mini-css-extract-plugin
module.exports = {"container":"_1y_AUjtA","header":"_3cEFLVRt","postsCount":"_3oZKf4gD","postsCountLabel":"_2_dpW2Tq","metricsDetail":"_3TU3ArGE","tooltipContent":"R4wZ8Cus"};